<page-heading
  [title]="
    isNew
      ? ('channel.channelForm.headingAdd' | translate)
      : ('channel.channelForm.headingEdit' | translate)
  "
  [description]="
    isNew
      ? ('channel.channelForm.headingAddDescription' | translate)
      : ('channel.channelForm.headingEditDescription' | translate)
  "
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

<form [formGroup]="formGroup">
  <div class="row mb-3">
    <div class="col-xs-12" [ngClass]="hasFormGroup ? 'col-sm-6 mb-2' : ''">
      <label class="form-label"
        >{{ "channel.channelForm.selectChannelTypeLabel" | translate }} *</label
      >
      <mat-select
        class="form-control"
        [placeholder]="'channel.channelForm.selectPlaceholder' | translate"
        formControlName="channelOption"
        (selectionChange)="onChannelOptionChange()"
        [disabled]="!company || channels.length === 0"
      >
        <mat-option
          [value]="cloudAPI"
          [disabled]="checkIfExceded(cloudAPI) || isOptionLocked(cloudAPI)"
        >
          Cloud API
          <small>{{
            checkIfExceded(cloudAPI)
              ? ("channel.channelForm.channelLimitExceeded" | translate)
              : ""
          }}</small>
        </mat-option>
        @if (
          (company?.enabledChannel?.maxCloudAPICreditLine || 0) > 0 ||
          channel?.creditLine
        ) {
          <!-- still a CLOUD_API channel; the credit line is fixed at creation -->
          <mat-option
            [value]="cloudAPICreditLine"
            [disabled]="
              checkIfExceded(cloudAPICreditLine) ||
              isOptionLocked(cloudAPICreditLine)
            "
          >
            {{ "channel.channelForm.cloudApiCreditLineOption" | translate }}
            <small>{{
              checkIfExceded(cloudAPICreditLine)
                ? ("channel.channelForm.channelLimitExceeded" | translate)
                : ""
            }}</small>
          </mat-option>
        }
        @if (
          (company?.enabledChannel?.maxCloudAPIHybrid || 0) > 0 ||
          channel?.hybrid
        ) {
          <!-- still a CLOUD_API channel; the hybrid mark is fixed at creation -->
          <mat-option
            [value]="cloudAPIHybrid"
            [disabled]="
              (isNew && checkIfExceded(cloudAPIHybrid)) ||
              isOptionLocked(cloudAPIHybrid)
            "
          >
            {{ "channel.channelForm.cloudApiHybridOption" | translate }}
            <small>{{
              isNew && checkIfExceded(cloudAPIHybrid)
                ? ("channel.channelForm.channelLimitExceeded" | translate)
                : ""
            }}</small>
          </mat-option>
        }
        <mat-option [value]="zAPI" [disabled]="checkIfExceded(zAPI)">
          TrendBusiness
          <small>{{
            checkIfExceded(zAPI)
              ? ("channel.channelForm.channelLimitExceeded" | translate)
              : ""
          }}</small>
        </mat-option>
        <mat-option
          [value]="instagramAPI"
          [disabled]="checkIfExceded(instagramAPI)"
        >
          Instagram
          <small>{{
            checkIfExceded(instagramAPI)
              ? ("channel.channelForm.channelLimitExceeded" | translate)
              : ""
          }}</small>
        </mat-option>
        <mat-option
          [value]="messengerAPI"
          [disabled]="checkIfExceded(messengerAPI)"
        >
          Messenger
          <small>{{
            checkIfExceded(messengerAPI)
              ? ("channel.channelForm.channelLimitExceeded" | translate)
              : ""
          }}</small>
        </mat-option>
        <mat-option [value]="rcsAPI" [disabled]="checkIfExceded(rcsAPI)">
          RCS
          <small>{{
            checkIfExceded(rcsAPI)
              ? ("channel.channelForm.channelLimitExceeded" | translate)
              : ""
          }}</small>
        </mat-option>
        @if (company?.modules?.moduleTrendVoip) {
          <mat-option [value]="voipAPI" [disabled]="checkIfExceded(voipAPI)">
            VoIP
            <small>
              {{
                checkIfExceded(voipAPI)
                  ? ("channel.channelForm.channelLimitExceeded" | translate)
                  : ""
              }}
            </small>
          </mat-option>
        }
        @if ((company?.enabledChannel?.maxWebchat || 0) > 0) {
          <mat-option
            [value]="webchatAPI"
            [disabled]="checkIfExceded(webchatAPI)"
          >
            Webchat
            <small>
              {{
                checkIfExceded(webchatAPI)
                  ? ("channel.channelForm.channelLimitExceeded" | translate)
                  : ""
              }}
            </small>
          </mat-option>
        }
      </mat-select>
      <field-error-component
        [field]="'channelOption'"
        [label]="'Canal'"
        [formGroup]="formGroup"
      />
    </div>

    @if (
      formGroup.get("type")?.value &&
      formGroup.get("type")?.value !== "INSTAGRAM_API" &&
      formGroup.get("type")?.value !== "MESSENGER_API"
    ) {
      <div class="col-xs-12 col-sm-6 col-xxl-4">
        <label class="form-label"
          >{{ "channel.channelForm.nameLabel" | translate }} *</label
        >
        <input
          maxlength="100"
          formControlName="name"
          class="form-control"
          [placeholder]="'channel.channelForm.namePlaceholder' | translate"
        />
        <field-error-component
          [field]="'name'"
          [label]="'Nome'"
          [formGroup]="formGroup"
        />
      </div>
    }
  </div>

  @if (formGroup.get("type")?.value === "CLOUD_API") {
    @if (formGroup.get("hybrid")?.value) {
      <div class="alert alert-info d-flex align-items-start gap-2" role="alert">
        <i class="ri-git-branch-line font-18"></i>
        <div>
          <strong>{{ "channel.channelForm.hybridTitle" | translate }}</strong>
          <div>{{ "channel.channelForm.hybridDescription" | translate }}</div>
          <div class="mt-1">{{ "channel.channelForm.hybridCoexistenceNote" | translate }}</div>
        </div>
      </div>
    }
    <div class="row mb-3">
      <div class="col-xs-12 col-sm-6 mb-2">
        <div class="card h-100 border-0">
          <div class="card-header bg-white border-0 text-center">
            <h5 class="card-title mb-0">
              {{ "channel.channelForm.cloudApiTitle" | translate }}
            </h5>
          </div>
          <div class="card-body">
            <p class="card-text">
              <strong>{{
                "channel.channelForm.whatsappBusinessApi" | translate
              }}</strong
              ><br />
              {{ "channel.channelForm.cloudApiDescription" | translate }}
            </p>
            <p class="card-text">
              {{ "channel.channelForm.cloudApiRedirectInfo" | translate }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-6 col-xxl-4">
        <div class="card w-100 h-100 border-0">
          <div class="card-header bg-white border-0 text-center">
            <h4 class="card-title mb-0">
              {{ "channel.channelForm.whatYouWillNeed" | translate }}
            </h4>
          </div>
          <div class="card-body">
            <ul class="list-required-items">
              <li>
                <i class="ri-file-list-2-line font-20 text-primary"></i>
                {{ "channel.channelForm.reqBusinessManagerAdmin" | translate }}
              </li>
              <li>
                <i class="ri-checkbox-circle-line font-20 text-primary"></i>
                {{ "channel.channelForm.reqViablePhone" | translate }}
              </li>
              <li>
                <i class="ri-shield-line font-20 text-primary"></i>
                {{ "channel.channelForm.reqLegalAddress" | translate }}
              </li>
              <li>
                <i class="ri-task-line font-20 text-primary"></i>
                {{ "channel.channelForm.reqSelectNumbers" | translate }}
              </li>
              <li>
                <i class="ri-checkbox-circle-line font-20 text-primary"></i>
                {{
                  "channel.channelForm.reqVerifyFacebookBusiness" | translate
                }}
              </li>
            </ul>
          </div>

          <div class="card-footer bg-white border-0 text-center">
            <div class="d-flex justify-content-center gap-2 flex-wrap">
              <span class="badge rounded-pill bg-success font-14 py-1 px-2"
                >WhatsApp</span
              >
              <span class="badge rounded-pill bg-primary font-14 py-1 px-2"
                >Meta</span
              >
              <span class="badge rounded-pill bg-primary font-14 py-1 px-2"
                >Trendmulti</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  } @else if (formGroup.get("type")?.value === "INSTAGRAM_API") {
    <div class="row mb-3">
      <div class="col-xs-12 col-sm-6 mb-3">
        <div class="card h-100 border-0">
          <div class="card-header bg-white border-0 text-center">
            <h4 class="card-title mb-0">
              {{ "channel.channelForm.instagramTitle" | translate }}
            </h4>
          </div>
          <div class="card-body">
            <p class="card-text">
              {{ "channel.channelForm.instagramDescription" | translate }}
            </p>
            <p class="card-text">
              <strong>{{
                "channel.channelForm.metaRedirectInfo" | translate
              }}</strong>
            </p>
          </div>
          <div
            class="card-footer bg-white border-0 d-flex justify-content-center align-items-center text-center gap-2"
          >
            <a
              [href]="instagramUrl"
              class="badge rounded-pill px-3 py-2 bg-primary font-14"
            >
              {{ "channel.channelForm.connectWithInstagram" | translate }}

              @if (loading) {
                <mat-spinner
                  [diameter]="25"
                  [color]="'accent'"
                  mode="indeterminate"
                />
              }
            </a>
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-6 col-xxl-4 mb-3">
        <div class="card h-100 border-0">
          <div class="card-header bg-white border-0 text-center">
            <h4 class="card-title mb-0">
              {{ "channel.channelForm.whatYouWillNeed" | translate }}
            </h4>
          </div>
          <div class="card-body">
            <ul class="list-required-items">
              <li>
                <i class="ri-file-list-2-line font-20 text-primary"></i>
                {{ "channel.channelForm.reqBusinessManagerAdmin" | translate }}
              </li>
              <li>
                <i class="ri-checkbox-circle-line font-20 text-primary"></i>
                {{ "channel.channelForm.reqConnectedFacebookPage" | translate }}
              </li>
              <li>
                <i class="ri-shield-line font-20 text-primary"></i>
                {{
                  "channel.channelForm.reqBusinessInstagramAccount" | translate
                }}
              </li>
              <li>
                <i class="ri-task-line font-20 text-primary"></i>
                {{ "channel.channelForm.reqAdminPermissions" | translate }}
              </li>
              <li>
                <i class="ri-checkbox-circle-line font-20 text-primary"></i>
                {{
                  "channel.channelForm.reqMetaBusinessVerification" | translate
                }}
              </li>
            </ul>

            <hr />

            <p
              class="text-muted fw-bold font-12 d-flex gap-3 align-items-center mb-0"
            >
              <i class="mdi mdi-label-outline font-20 text-warning"></i>
              {{ "channel.channelForm.facebookLoginWarning" | translate }}
            </p>
          </div>
          <div class="card-footer bg-white border-0 text-center">
            <div class="d-flex justify-content-center gap-2 flex-wrap">
              <span class="badge rounded-pill bg-success font-14 py-1 px-2"
                >Instagram</span
              >
              <span class="badge rounded-pill bg-primary font-14 py-1 px-2"
                >Meta</span
              >
              <span class="badge rounded-pill bg-primary font-14 py-1 px-2"
                >Trendmulti</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="card h-100 border-0">
          <div class="card-header bg-white border-0">
            <h4 class="card-title mb-0">
              {{ "channel.channelForm.instagramFacebookTitle" | translate }}
            </h4>
          </div>
          <div class="card-body">
            <p class="card-text">
              {{
                "channel.channelForm.instagramFacebookDescription" | translate
              }}
              <br />
              {{ "channel.channelForm.metaRedirectInfo" | translate }}
            </p>
          </div>
        </div>
      </div>
    </div>
  } @else if (formGroup.get("type")?.value === "MESSENGER_API") {
    <div class="row mb-3">
      <div class="col-xs-12 col-sm-6 mb-3">
        <div class="card h-100 border-0">
          <div class="card-header bg-white border-0 text-center">
            <h4 class="card-title mb-0">
              {{ "channel.channelForm.messengerTitle" | translate }}
            </h4>
          </div>
          <div class="card-body">
            <p class="card-text">
              {{ "channel.channelForm.messengerDescription" | translate }}
            </p>
            <p class="card-text">
              <strong>{{
                "channel.channelForm.metaRedirectInfo" | translate
              }}</strong>
            </p>
          </div>
          <div
            class="card-footer bg-white border-0 d-flex justify-content-center align-items-center text-center gap-2"
          >
            <a
              [href]="messengerUrl"
              class="badge rounded-pill px-3 py-2 bg-primary font-14"
            >
              {{ "channel.channelForm.connectWithMessenger" | translate }}

              @if (loading) {
                <mat-spinner
                  [diameter]="25"
                  [color]="'accent'"
                  mode="indeterminate"
                />
              }
            </a>
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-6 col-xxl-4 mb-3">
        <div class="card h-100 border-0">
          <div class="card-header bg-white border-0 text-center">
            <h4 class="card-title mb-0">
              {{ "channel.channelForm.whatYouWillNeed" | translate }}
            </h4>
          </div>
          <div class="card-body">
            <ul class="list-required-items">
              <li>
                <i class="ri-file-list-2-line font-20 text-primary"></i>
                {{ "channel.channelForm.reqBusinessManagerAdmin" | translate }}
              </li>
              <li>
                <i class="ri-checkbox-circle-line font-20 text-primary"></i>
                {{ "channel.channelForm.reqConnectedFacebookPage" | translate }}
              </li>
              <li>
                <i class="ri-task-line font-20 text-primary"></i>
                {{ "channel.channelForm.reqAdminPermissions" | translate }}
              </li>
              <li>
                <i class="ri-checkbox-circle-line font-20 text-primary"></i>
                {{
                  "channel.channelForm.reqMetaBusinessVerification" | translate
                }}
              </li>
            </ul>
          </div>
          <div class="card-footer bg-white border-0 text-center">
            <div class="d-flex justify-content-center gap-2 flex-wrap">
              <span class="badge rounded-pill bg-success font-14 py-1 px-2"
                >Messenger</span
              >
              <span class="badge rounded-pill bg-primary font-14 py-1 px-2"
                >Meta</span
              >
              <span class="badge rounded-pill bg-primary font-14 py-1 px-2"
                >Trendmulti</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="card h-100 border-0">
          <div class="card-header bg-white border-0">
            <h4 class="card-title mb-0">
              {{ "channel.channelForm.messengerFacebookTitle" | translate }}
            </h4>
          </div>
          <div class="card-body">
            <p class="card-text">
              {{
                "channel.channelForm.messengerFacebookDescription" | translate
              }}
              <br />
              {{ "channel.channelForm.metaRedirectInfo" | translate }}
            </p>
          </div>
        </div>
      </div>
    </div>
  } @else if (formGroup.get("type")?.value === "RCS_API") {
    <div class="row mb-3">
      <div class="col-xs-12 col-sm-6 mb-3">
        <div class="card h-100 border-0">
          <div class="card-header bg-white border-0 text-center">
            <h4 class="card-title mb-0">
              {{ "channel.channelForm.rcsTitle" | translate }}
            </h4>
          </div>
          <div class="card-body">
            <div class="d-flex flex-column" formGroupName="credentials">
              <div class="d-flex flex-column mb-3">
                <label class="form-label">{{
                  "channel.channelForm.account" | translate
                }}</label>
                <input
                  formControlName="account"
                  class="form-control"
                  [placeholder]="
                    'channel.channelForm.accountPlaceholder' | translate
                  "
                />
                <field-error-component
                  [field]="'credentials.account'"
                  [label]="'Conta'"
                  [formGroup]="formGroup"
                >
                </field-error-component>
              </div>
            </div>
            <!--
              RCS is conversational-only: there is no campaign-only ("single") account any more,
              so the capability is no longer an operator choice. The switch is kept commented out
              (with its i18n keys) in case the distinction ever comes back. The `rcs` FormGroup
              still exists in the component and always saves `conversational: true`.

            <div
              class="d-flex justify-content-between align-items-center mt-3"
              formGroupName="rcs"
            >
              <div class="me-3">
                <h5 class="mb-0 fw-bold">
                  {{ "channel.channelForm.rcsConversationalLabel" | translate }}
                </h5>
                <p class="text-muted mb-0">
                  {{ "channel.channelForm.rcsConversationalHelp" | translate }}
                </p>
              </div>
              <div class="custom-switch">
                <input
                  type="checkbox"
                  id="rcsConversational"
                  data-switch="success"
                  formControlName="conversational"
                />
                <label for="rcsConversational"></label>
              </div>
            </div>
            -->
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-6 col-xxl-4 mb-3">
        <div class="card w-100 h-100 border-0">
          <div class="card-header bg-white border-0 text-center">
            <h4 class="card-title mb-0">
              {{ "channel.channelForm.whatYouWillNeed" | translate }}
            </h4>
          </div>
          <div class="card-body">
            <ul class="list-required-items">
              <li>
                <i class="ri-file-list-2-line font-20 text-primary"></i
                >{{ "channel.channelForm.rcsReqContractedAccount" | translate }}
              </li>
              <li>
                <i class="ri-checkbox-circle-line font-20 text-primary"></i
                >{{ "channel.channelForm.rcsReqApprovedAgent" | translate }}
              </li>
            </ul>
          </div>
          <div class="card-footer bg-white border-0 text-center">
            <div class="d-flex justify-content-center gap-2 flex-wrap">
              <span class="badge rounded-pill bg-success font-14 py-1 px-2"
                >RCS</span
              >
              <span class="badge rounded-pill bg-primary font-14 py-1 px-2"
                >Google</span
              >
              <span class="badge rounded-pill bg-primary font-14 py-1 px-2"
                >Trendmulti</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  } @else if (formGroup.get("type")?.value === "VOIP_API") {
    <div class="row mb-3">
      <div class="col-xs-12 col-sm-6 mb-3">
        <div class="card h-100 border-0">
          <div class="card-header bg-white border-0 text-center">
            <h4 class="card-title mb-0">
              {{ "channel.channelForm.voipConnectPbxTitle" | translate }}
            </h4>
          </div>
          <div class="card-body">
            <p class="card-text text-muted">
              {{ "channel.channelForm.voipConnectPbxDescription" | translate }}
            </p>
            <div class="d-flex flex-column" formGroupName="credentials">
              <div class="row">
                <div class="col-sm-8 mb-3">
                  <label class="form-label">
                    {{ "channel.channelForm.voipSipServerLabel" | translate }}
                    <span class="text-danger">*</span>
                  </label>
                  <input
                    formControlName="server"
                    class="form-control"
                    placeholder="Ex.: voz.suaoperadora.com.br"
                  />
                  <field-error-component
                    [field]="'credentials.server'"
                    [label]="'channel.channelForm.voipSipServerShortLabel' | translate"
                    [formGroup]="formGroup"
                  />
                </div>
                <div class="col-sm-4 mb-3">
                  <label class="form-label">
                    {{ "channel.channelForm.voipPortLabel" | translate }}
                    <span class="text-danger">*</span>
                  </label>
                  <input
                    formControlName="port"
                    type="number"
                    class="form-control"
                    placeholder="Ex.: 5060"
                  />
                  <field-error-component
                    [field]="'credentials.port'"
                    [label]="'channel.channelForm.voipPortLabel' | translate"
                    [formGroup]="formGroup"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6 mb-3">
                  <label class="form-label">
                    {{ "channel.channelForm.voipSipUsernameLabel" | translate }}
                    <span class="text-danger">*</span>
                  </label>
                  <input
                    formControlName="username"
                    class="form-control"
                    placeholder="Ex.: 6130202140"
                  />
                  <field-error-component
                    [field]="'credentials.username'"
                    [label]="'channel.channelForm.voipSipUsernameShortLabel' | translate"
                    [formGroup]="formGroup"
                  />
                </div>
                <div class="col-sm-6 mb-3">
                  <label class="form-label">
                    {{ "channel.channelForm.voipSipPasswordLabel" | translate }}
                    <span class="text-danger">*</span>
                  </label>
                  <input
                    formControlName="secret"
                    type="password"
                    class="form-control"
                    [placeholder]="
                      'channel.channelForm.voipSipPasswordPlaceholder' | translate
                    "
                  />
                  <field-error-component
                    [field]="'credentials.secret'"
                    [label]="'channel.channelForm.voipSipPasswordLabel' | translate"
                    [formGroup]="formGroup"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-6 col-xxl-4 mb-3">
        <div class="card w-100 h-100 border-0">
          <div class="card-header bg-white border-0 text-center">
            <h4 class="card-title mb-0">
              {{ "channel.channelForm.whatYouWillNeed" | translate }}
            </h4>
          </div>
          <div class="card-body">
            <ul class="list-required-items">
              <li>
                <i class="ri-server-line font-20 text-primary"></i
                >{{ "channel.channelForm.voipReqIssabelServer" | translate }}
              </li>
              <li>
                <i class="ri-global-line font-20 text-primary"></i
                >{{ "channel.channelForm.voipReqWssPort" | translate }}
              </li>
              <li>
                <i class="ri-phone-line font-20 text-primary"></i
                >{{ "channel.channelForm.voipReqExtensionsList" | translate }}
              </li>
            </ul>
          </div>
          <div class="card-footer bg-white border-0 text-center">
            <div class="d-flex justify-content-center gap-2 flex-wrap">
              <span class="badge rounded-pill bg-info font-14 py-1 px-2">
                VoIP
              </span>
              <span class="badge rounded-pill bg-primary font-14 py-1 px-2">
                Issabel
              </span>
              <span class="badge rounded-pill bg-primary font-14 py-1 px-2">
                Trendmulti
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  } @else if (formGroup.get("type")?.value === "WEBCHAT_API") {
    <div class="row mb-3">
      <div class="col-xs-12 col-sm-6 mb-3">
        <div class="card h-100 border-0">
          <div class="card-header bg-white border-0 text-center">
            <h4 class="card-title mb-0">
              {{ "channel.channelForm.webchatCustomizationTitle" | translate }}
            </h4>
          </div>
          <div class="card-body">
            <p class="card-text text-muted">
              {{
                "channel.channelForm.webchatCustomizationDescription"
                  | translate
              }}
            </p>
            <div class="d-flex flex-column" formGroupName="webchat">
              <div class="row">
                <div class="col-sm-6 mb-3">
                  <label class="form-label">{{
                    "channel.channelForm.webchatPrimaryColorLabel" | translate
                  }}</label>
                  <input
                    formControlName="primaryColor"
                    type="color"
                    class="form-control form-control-color w-100"
                  />
                </div>
                <div class="col-sm-6 mb-3">
                  <label class="form-label">{{
                    "channel.channelForm.webchatButtonPositionLabel" | translate
                  }}</label>
                  <mat-select class="form-control" formControlName="buttonPosition">
                    <mat-option value="right">{{
                      "channel.channelForm.webchatButtonPositionRight"
                        | translate
                    }}</mat-option>
                    <mat-option value="left">{{
                      "channel.channelForm.webchatButtonPositionLeft" | translate
                    }}</mat-option>
                  </mat-select>
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label">{{
                  "channel.channelForm.webchatLogoLabel" | translate
                }}</label>
                <webchat-logo-upload-component formControlName="logoUrl" />
              </div>
              <div class="mb-3">
                <label class="form-label">{{
                  "channel.channelForm.webchatPrivacyPolicyUrlLabel" | translate
                }}</label>
                <input
                  formControlName="privacyPolicyUrl"
                  class="form-control"
                  placeholder="https://"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-6 col-xxl-4 mb-3">
        <div class="card w-100 h-100 border-0">
          <div class="card-header bg-white border-0 text-center">
            <h4 class="card-title mb-0">
              {{ "channel.channelForm.whatYouWillNeed" | translate }}
            </h4>
          </div>
          <div class="card-body">
            <ul class="list-required-items">
              <li>
                <i class="ri-code-s-slash-line font-20 text-primary"></i
                >{{ "channel.channelForm.webchatReqSiteAccess" | translate }}
              </li>
              <li>
                <i class="ri-links-line font-20 text-primary"></i
                >{{ "channel.channelForm.webchatReqEmbedAfterCreate" | translate }}
              </li>
              <li>
                <i class="ri-palette-line font-20 text-primary"></i
                >{{ "channel.channelForm.webchatReqCustomizeAnytime" | translate }}
              </li>
            </ul>
          </div>
          <div class="card-footer bg-white border-0 text-center">
            <div class="d-flex justify-content-center gap-2 flex-wrap">
              <span class="badge rounded-pill bg-info font-14 py-1 px-2">
                Webchat
              </span>
              <span class="badge rounded-pill bg-primary font-14 py-1 px-2">
                Trendmulti
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</form>

<hr class="mt-4" />

<div class="col-12 gap-2 my-4 d-flex justify-content-end">
  <button class="btn btn-light" (click)="goBack()">
    {{ "channel.channelForm.cancel" | translate }}
  </button>
  <button
    class="btn btn-success"
    (click)="save()"
    [disabled]="!formGroup.valid || loading"
    [ngStyle]="{
      cursor: !formGroup.valid || loading ? 'not-allowed' : 'pointer',
    }"
  >
    {{
      isNew
        ? ("channel.channelForm.save" | translate)
        : ("channel.channelForm.update" | translate)
    }}
  </button>
</div>
